/**
 * @file components/TertiaryNav/component.js
 * @copyright 2017 CBC/Radio-Canada. All rights reserved.
 * @author Fitore Jaha [fitore.jaha@cbc.ca]
 */

import PropTypes from "prop-types";
import ResponsiveNav from "../ResponsiveNav/component";
import classNames from "classnames";
import { HIDE_TERTIARY_NAV } from "./constants";
import {
    isDetailPage,
    stripStoryFromNav,
} from "../../../../utils/path/library";

/**
 * The TertiaryNav component.
 *
 * This is the tertiary (third) level of navigation, e.g. used on Sports pages
 *
 * @param {Object} props The component props
 * @returns Returns the TertiaryNav component
 */

export default function TertiaryNav({
    items = null,
    baseNavSection,
    subSection,
    path = "",
    viewport,
    moreButtonLabel = "More",
    isExternalHeader = false,
    contentId,
}) {
    if (
        HIDE_TERTIARY_NAV[path] ||
        (isDetailPage({ contentId: contentId }) &&
            HIDE_TERTIARY_NAV[stripStoryFromNav(path)])
    ) {
        return null;
    }

    const classes = classNames("sclt-tertiarynav", {
        tertiaryNav: true,
    });

    // Get the navigation JSON object from the constants file
    let subNavList = items ? items : null;
    if (!Array.isArray(subNavList)) {
        return null;
    }

    // The "More" button needs to pass the section name, so pull it from the first item
    const firstItem = subNavList[0] || null;
    const sectionTitle = firstItem ? firstItem.title : "";

    const navProps = {
        baseNavSection,
        subSection,
        path,
        showLogo: false,
        items: subNavList,
        viewport,
        gemDepartment: null,
        isExternalHeader,
        moreButtonLabel: sectionTitle
            ? `More ${sectionTitle.replace("Home", "")}`
            : moreButtonLabel,
    };

    return (
        <nav className={classes}>
            <div className="tertiaryNavWrapper">
                <ResponsiveNav {...navProps} />
            </div>
        </nav>
    );
}

TertiaryNav.propTypes = {
    items: PropTypes.array,
    baseNavSection: PropTypes.string,
    subSection: PropTypes.string,
    path: PropTypes.string,
    viewport: PropTypes.string,
    moreButtonLabel: PropTypes.string,
    isExternalHeader: PropTypes.bool,
    contentId: PropTypes.string,
};
